<template>
  <v-card
    class="rounded-xl ma-2 pa-5"
    min-width="300px"
    max-width="500px"
  >
    <v-card-title>
      Description
    </v-card-title>

    <v-card
      v-for="(description, indexDescriptions) in descriptions"
      :key="indexDescriptions"
      flat
    >
      <v-card-subtitle class="ppc_darkgreen--text">
        {{ description.Title }}
      </v-card-subtitle>

      <v-card-text>
        <v-textarea
          v-model.trim="service[description.Value]"
          :counter=description.data_length
          auto-grow
          validate-on-blur
          clearable
          :rules="[
            v => (v || '').length <= description.data_length ||
              'Description length too long'
          ]"
          :disabled="$store.getters.loadingApp === 1"
        />
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'ServiceDescriptions',

  props: {
    service: {
      type: Object,
      default: () => ({}),
    },

    descriptions: {
      type: Array,
      default: () => [],
    },
  },
}
</script>